import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33edc5f7")

_pushScopeId("data-v-33edc5f7")
const _hoisted_1 = { class: "preview-wrap datatable-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-12 col-md-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col-12 col-md-10" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list_container = _resolveComponent("list-container")
  const _component_chart_container = _resolveComponent("chart-container")
  const _component_table_container = _resolveComponent("table-container")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_tabs, {
      type: "card",
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = $event)),
      onTabClick: _ctx.onTabSelected
    }, {
      default: _withId(() => [
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('default.search_form.person'),
          name: _ctx.Config.CONSTANTS.PERSON,
          disabled: !_ctx.dataToDisplay.person
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.containers, (items, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "container-wrap",
                index: index
              }, [
                (_ctx.isAllowedInScope(items))
                  ? (_openBlock(), _createBlock("div", _hoisted_2, [
                      _createVNode("div", _hoisted_3, [
                        (_ctx.canShowContianer(items, _ctx.ContainerType.COMPOSITE))
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              id: 'container' + index
                            }, [
                              (items.title)
                                ? (_openBlock(), _createBlock("h1", _hoisted_4, _toDisplayString(items.title), 1))
                                : _createCommentVNode("", true),
                              (items.sub_title)
                                ? (_openBlock(), _createBlock("h5", _hoisted_5, _toDisplayString(items.sub_title), 1))
                                : _createCommentVNode("", true)
                            ], 8, ["id"]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "heading",
                              id: 'container' + index
                            }, [
                              (items.title)
                                ? (_openBlock(), _createBlock("h2", _hoisted_6, _toDisplayString(items.title), 1))
                                : _createCommentVNode("", true),
                              (items.sub_title)
                                ? (_openBlock(), _createBlock("h5", _hoisted_7, _toDisplayString(items.sub_title), 1))
                                : _createCommentVNode("", true)
                            ], 8, ["id"]))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.canShowContianer(items, _ctx.ContainerType.LIST))
                  ? (_openBlock(), _createBlock(_component_list_container, {
                      key: 1,
                      container: items
                    }, null, 8, ["container"]))
                  : _createCommentVNode("", true),
                (_ctx.canShowContianer(items, _ctx.ContainerType.CHART))
                  ? (_openBlock(), _createBlock(_component_chart_container, {
                      key: 2,
                      container: items,
                      id: index,
                      index: index
                    }, null, 8, ["container", "id", "index"]))
                  : _createCommentVNode("", true),
                (_ctx.canShowContianer(items, _ctx.ContainerType.TABLE))
                  ? (_openBlock(), _createBlock(_component_table_container, {
                      key: 3,
                      container: items
                    }, null, 8, ["container"]))
                  : _createCommentVNode("", true)
              ], 8, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label", "name", "disabled"]),
        _createVNode(_component_el_tab_pane, {
          label: _ctx.$t('default.search_form.company'),
          name: _ctx.Config.CONSTANTS.COMPANY,
          disabled: !_ctx.dataToDisplay.company
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.containers, (items, index) => {
              return (_openBlock(), _createBlock("div", {
                key: index,
                class: "container-wrap",
                index: index
              }, [
                (_ctx.isAllowedInScope(items))
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        (_ctx.canShowContianer(items, _ctx.ContainerType.COMPOSITE))
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              id: 'container' + index
                            }, [
                              (items.title)
                                ? (_openBlock(), _createBlock("h1", _hoisted_10, _toDisplayString(items.title), 1))
                                : _createCommentVNode("", true),
                              (items.sub_title)
                                ? (_openBlock(), _createBlock("h5", _hoisted_11, _toDisplayString(items.sub_title), 1))
                                : _createCommentVNode("", true)
                            ], 8, ["id"]))
                          : (_openBlock(), _createBlock("div", {
                              key: 1,
                              class: "heading",
                              id: 'container' + index
                            }, [
                              (items.title)
                                ? (_openBlock(), _createBlock("h2", _hoisted_12, _toDisplayString(items.title), 1))
                                : _createCommentVNode("", true),
                              (items.sub_title)
                                ? (_openBlock(), _createBlock("h5", _hoisted_13, _toDisplayString(items.sub_title), 1))
                                : _createCommentVNode("", true)
                            ], 8, ["id"]))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.canShowContianer(items, _ctx.ContainerType.LIST))
                  ? (_openBlock(), _createBlock(_component_list_container, {
                      key: 1,
                      container: items
                    }, null, 8, ["container"]))
                  : _createCommentVNode("", true),
                (_ctx.canShowContianer(items, _ctx.ContainerType.CHART))
                  ? (_openBlock(), _createBlock(_component_chart_container, {
                      key: 2,
                      container: items,
                      id: index,
                      index: index
                    }, null, 8, ["container", "id", "index"]))
                  : _createCommentVNode("", true),
                (_ctx.canShowContianer(items, _ctx.ContainerType.TABLE))
                  ? (_openBlock(), _createBlock(_component_table_container, {
                      key: 3,
                      container: items
                    }, null, 8, ["container"]))
                  : _createCommentVNode("", true)
              ], 8, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label", "name", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]), [
      [_vShow, _ctx.showTab]
    ])
  ]))
})